<div class="resposta-content">
  <app-loading-spinner *ngIf="showSpinner"></app-loading-spinner>

  <div *ngIf="!showSpinner">
    <app-menu></app-menu>
    <ng-container *ngIf="questao$ | async as questao">
      <div *ngIf="questaoSource$ | async as source" class="questao-titulo">

        <mat-card class="questao-card">

          <mat-card-title style="text-align: center;">
            <h2>{{ source.questao }}</h2>
          </mat-card-title>

          <mat-card-subtitle>
            <p class="questao-autor"> Autor: {{ source.userDisplayName }}</p>
            <p class="questao-descricao"> {{ source.descricao }}</p>
          </mat-card-subtitle>

          <mat-card-content>
            <mat-card class="forum" *ngFor="let msg of questao.respostas; trackBy: trackByCreated">
              <mat-card-title class="user">
                <div class="row">
                  <img [src]="msg.user?.photoURL">
                  <span>
                    <p class="user-autor">{{ msg.user?.displayName || msg.user.uid }}</p>
                    <p class="user-criadoem">{{ msg.time | date }} - {{ msg.time | date:'shortTime'}} </p>
                  </span>
                </div>
              </mat-card-title>
              <mat-card-content class="msg" >
                <p>{{ msg.resposta }}</p>
              </mat-card-content>
              <mat-divider></mat-divider>
            </mat-card>

            <div #send class="form">
              <mat-form-field style="width: 90%;">
                <input matInput placeholder="Digite sua resposta aqui" [(ngModel)]="newMsg" (keydown.enter)="submit(questao.id)">
              </mat-form-field>
              <a (click)="submit(questao.id)"><mat-icon class="send-button">send</mat-icon></a>
            </div>

          </mat-card-content>
        </mat-card>
      </div>
    </ng-container>
  </div>
